import React , {Component} from "react";
class  Route_Loading extends Component{
	render(){
		return (
			<div>loading</div>
		)
	}
}
export default Route_Loading;